import { FunctionComponent } from 'react';
import { FeedCardAdmin } from '../../components';
import { SearchFeedCommon } from '../../shared';

export const SearchFeedAdmin: FunctionComponent = () => {
  return <SearchFeedCommon CardComponent={FeedCardAdmin} />;
};
